import { memo } from "react";
import MaxWidthLayout from "./MaxWidthLayout";

import ApplyLinkButton from "./ApplyLinkButton";
import arrow from "../assets/img/Desktop/Vector@2x.png";

const ProceduresWrapper = ({ children }) => {
  return (
    <div className="flex flex-col lg:flex-row border border-solid border-black rounded-15px md:rounded-30px  w-90% md:w-80% lg:pl-60px py-24px lg:py-40px max-w-828px items-center m-auto bg-white">
      {children}
    </div>
  );
};
const ProceduresNumber = ({ children }) => {
  return (
    <p className="w-32px md:w-52px h-32px md:h-52px bg-green-1 text-white text-lg md:text-4xl font-semibold border border-solid border-black rounded-full flex justify-center items-center mb-8px lg:mb-0 mr-0 lg:mr-24px">
      {children}
    </p>
  );
};
const ProceduresTitle = ({ children }) => {
  return (
    <h3 className="text-green-1 text-lg md:text-28px font-semibold mb-8px lg:mb-0 mr-0 lg:mr-22px">
      {children}
    </h3>
  );
};

const ApplicationProcedures = () => {
  return (
    <MaxWidthLayout>
      <div
        className="pt-64px md:pt-112px text-black-1"
        id="applicationProcedures"
      >
        <h2 className="text-green-1 text-26px md:text-4xl font-semibold  text-center pb-40px">
          申請流程
        </h2>
        <ProceduresWrapper>
          <ProceduresNumber>１</ProceduresNumber>
          <ProceduresTitle>瞭解 活動資格</ProceduresTitle>
          <p className="text-14px md:text-xl text-center">
            至Meteor學生社群
            <br className="mb:hidden" />
            觀看{" "}
            <a
              // href="https://meteor.today/article/rN09t9?utm_source=scholarship&utm_medium=post20220803"
              href="https://meteor.today/article/0xtQrE"
              className="text-green-1 underline"
              target="_blank"
              rel="noreferrer"
            >
              完整文章
            </a>{" "}
            及申請資格
          </p>
        </ProceduresWrapper>
        <div className="flex justify-center py-30px">
          <img src={arrow} alt="箭頭" className="w-30px inline-block" />
        </div>
        <ProceduresWrapper>
          <ProceduresNumber>２</ProceduresNumber>
          <ProceduresTitle>點選 報名連結</ProceduresTitle>
          <p className="text-14px md:text-xl">完整填寫後送出，即可完成報名！</p>
          <ApplyLinkButton className={"mt-24px lg:mt-0 lg:ml-8px"} />
        </ProceduresWrapper>
      </div>
    </MaxWidthLayout>
  );
};

export default memo(ApplicationProcedures);
